<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    [validationRules]="validationRulesMap" [validationV2]="validationV2"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>  
    <dx-popup *ngIf="crudPopupVisible"
    title="Birim Dosya Plan"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
    <dx-scroll-view width="100%" height="100%">

        <dk-ctl-gas-birim-dosya-belge-arama
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)">
        </dk-ctl-gas-birim-dosya-belge-arama>
    </dx-scroll-view>
</dx-popup>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
